import React from "react";
import HistoricalUnitPricesPage from "./HistoricalUnitPricesPage";

const AnzHistoricalUnitPrices = () => (
  <HistoricalUnitPricesPage
    pageTitle="ANZ Historical Unit Prices"
    reportName="ANZUnitPrice"
    fundsLocalFilePath={process.env.REACT_APP_ANZ_FUNDS_LOCAL_DATA}
    historicalLocalFilePath={process.env.REACT_APP_ANZ_HISTORICAL_LOCAL_DATA}
  />
);

export default AnzHistoricalUnitPrices;